import { apiResultSuccess, getWorkoutsData } from "../apihelper";
import Board from "../models/board";
import Workout from "../models/workout";

export default class WorkoutsController extends Board {
    constructor(
        id=-1, 
        title='', 
        type='', 
        orderIndex=-1,
        dateCreated='', 
        lastUpdated='', 
        hidden=false
    ) {
        super(parseInt(id), title, type, orderIndex, dateCreated, lastUpdated, hidden);

        this.workouts = [];
    }

    getWorkouts() {
        return this.workouts;
    }

    setWorkouts(newWorkouts=[]) {
        this.workouts = newWorkouts;
    }

    // API helper
    // Checks for success result
    // Upon success calls createWorkouts
    // Runs reload on subject
    handleAPIResult(results) {
        if ( apiResultSuccess(results) ) {
            if ( results.workouts ) {
                this.createWorkouts(results.workouts);
                this.subject.runReload();
            }
        }
    }

    async fetchData() {
        return this.fetchWorkouts();
    }

    // Fetch workouts from API
    // When done call handleAPIResult
    fetchWorkouts() {
        getWorkoutsData(
            (results) => {
                this.handleAPIResult(results);
            }, this.id
        );
    }

    // Refetch workouts
    async reloadData() {
        return this.fetchWorkouts();
    }

    // Iterates through newWorkouts
    // Creates a Workout for each
    // appends it to a new array
    // Updates workouts with new array
    createWorkouts(newWorkouts=[]) {
        const workouts = [];

        newWorkouts.forEach(data => {
            const workout = new Workout(data);
            workouts.push(workout);
        });

        this.setWorkouts(workouts);
    }

    // Creates a new workout from newData
    // Adds it to workouts array
    // Notifies subject to reload
    addNew(newData) {
        const newWorkout = new Workout(newData);
        newWorkout.animate = true;
        this.workouts.push(newWorkout);
        this.subject.runReload();
    }

    // Filter workouts array by id
    // Assign to workouts
    // Notifies subject to reload
    delete(id=-1) {
        if ( id !== -1 ) {
            const newWorkouts = this.workouts.filter(workout => workout.id !== id);
            this.setWorkouts(newWorkouts);
            this.subject.runReload();
        }
    }
}